import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    HostBinding,
    inject,
    input,
    model
} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    ControlContainer,
    FormGroupDirective,
    AbstractControl,
    ValidationErrors
} from '@angular/forms';
import { Store } from '@ngxs/store';
import { ZSelectComponent } from '@shared/components/form-components/z-select/z-select.component';

@Component({
    selector: 'z-invoice-move-purposes',
    templateUrl: './z-invoice-move-purposes.component.html',
    styleUrl: './z-invoice-move-purposes.component.scss',
    imports: [FormsModule, ReactiveFormsModule, ZSelectComponent],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZInvoiceMovePurposesComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZInvoiceMovePurposesComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZInvoiceMovePurposesComponent {
    @HostBinding('class') class?: string = 'flex flex-auto min-w-[210px]';
    mode = model<'edit' | 'view'>('view');
    label = input<string | undefined>('Σκοπός Διακίνησης');
    showLabel = input<boolean | undefined>(true);
    showClear = input<boolean | undefined>();
    filter = input<boolean | undefined>();
    autocomplete = input<string | undefined>();
    id = input<string | undefined>();
    optionLabel = input<string | undefined>('Title');
    optionValue = input<string | undefined>('_id');
    options = model<InvoiceMovePurpose[] | undefined>();
    placeholder = input<string | undefined>();
    store = inject(Store);
    constructor() {
        // this.store
        //   .select(VATCategoryGraphQLSchemaSelectors.FetchSelector('', ''))
        //   .pipe(takeUntilDestroyed())
        //   .subscribe((value) => {
        //     this.options.set(value?.data?.Fetch);
        //   });
    }

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled?: boolean;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        this.model = obj;
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */

    ngOnInit() {
        this.loadData();
    }

    //     1 Πώληση
    // 2 Πώληση για Λογαριασμό Τρίτων
    // 3 Δειγματισμός
    // 4 Έκθεση
    // 5 Επιστροφή
    // 6 Φύλαξη
    // 7 Επεξεργασία Συναρμολόγηση
    // 8 Μεταξύ Εγκαταστάσεων Οντότητας
    // 9 Αγορά
    // 10 Εφοδιασμός πλοίων και αεροσκαφών
    // 11 Δωρεάν διάθεση
    // 12 Εγγύηση
    // 13 Χρησιδανεισμός
    // 14 Αποθήκευση σε Τρίτους
    // 15 Επιστροφή από Φύλαξη
    // 16 Ανακύκλωση
    // 17 Καταστροφή άχρηστου υλικού
    // 18 Διακίνηση Παγίων (Ενδοδιακίνηση)
    // 19 Λοιπές Διακινήσεις
    loadData() {
        this.options.set([
            { _id: 1, Title: 'Πώληση' },
            { _id: 2, Title: 'Πώληση για Λογαριασμό Τρίτων' },
            { _id: 3, Title: 'Δειγματισμός' },
            { _id: 4, Title: 'Έκθεση' },
            { _id: 5, Title: 'Επιστροφή' },
            { _id: 6, Title: 'Φύλαξη' },
            { _id: 7, Title: 'Επεξεργασία Συναρμολόγηση' },
            { _id: 8, Title: 'Μεταξύ Εγκαταστάσεων Οντότητας' },
            { _id: 9, Title: 'Αγορά' },
            { _id: 10, Title: 'Εφοδιασμός πλοίων και αεροσκαφών' },
            { _id: 11, Title: 'Δωρεάν διάθεση' },
            { _id: 12, Title: 'Εγγύηση' },
            { _id: 13, Title: 'Χρησιδανεισμός' },
            { _id: 14, Title: 'Αποθήκευση σε Τρίτους' },
            { _id: 15, Title: 'Επιστροφή από Φύλαξη' },
            { _id: 16, Title: 'Ανακύκλωση' },
            { _id: 17, Title: 'Καταστροφή άχρηστου υλικού' },
            { _id: 18, Title: 'Διακίνηση Παγίων (Ενδοδιακίνηση)' },
            { _id: 19, Title: 'Λοιπές Διακινήσεις' }
        ]);
    }

    modelChange(_id: string) {
        this.onModelChange(_id);
    }
}

export type InvoiceMovePurpose = {
    _id: number;
    Title: string;
};
